import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  FetchUserListResponse,
  UserFormValue,
  UserListQueryParam,
} from '@shared/models';
import { buildHttpParamsFromQueryParams } from '@shared/utils';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';


@Injectable({
  providedIn: 'root',
})
export class UserService {
  #http = inject(HttpClient);
  #apiUrl = environment.apiUrl;
  #authHeaders = new HttpHeaders({
    Authorization: '',
  });
  constructor(private http: HttpClient) {}

  createUser(formValue: UserFormValue) {
    
    const payload: Record<string, unknown> = {
      firstname: formValue.name,
      lastname: formValue.lastname,
      email: formValue.email,
      id_number: formValue.dni,
      phone_number: formValue.phone,
      profile: formValue.roleId,
      company_id: formValue.companyId,
    };
    // Only sent when explicitly set: without it the backend keeps its DNI fallback.
    if (formValue.password) {
      payload['password'] = formValue.password;
      payload['password_confirmation'] = formValue.passwordConfirmation;
    }
    return this.#http.post(`${this.#apiUrl}/api/register`, payload, {
      headers: this.#authHeaders,
    });
  }

  editUser(formValue: UserFormValue, userId: string, userData: UserFormValue) {
    const payload =
      formValue.email === userData.email
        ? {
            firstname: formValue.name,
            lastname: formValue.lastname,
            phone_number: formValue.phone,
            company_id: formValue.companyId,
          }
        : {
            firstname: formValue.name,
            lastname: formValue.lastname,
            email: formValue.email,
            phone_number: formValue.phone,
            company_id: formValue.companyId,
          };
    return this.#http.patch(`${this.#apiUrl}/api/admin/${userId}`, payload, {
      headers: this.#authHeaders,
    });
  }

  fetchUsers(queryParams?: Partial<UserListQueryParam>) {
    const params = buildHttpParamsFromQueryParams(queryParams);
   
    return this.#http.get<FetchUserListResponse>(
      `${this.#apiUrl}/api/superadmin/list`,
      {
        headers: this.#authHeaders,
        params,
      }
    );
  }

  fetchUserAdmin(userId: string) {
    return this.#http
      .get(`${this.#apiUrl}/api/admin/${userId}`, {
        headers: this.#authHeaders,
      })
      .pipe(
        map((response: any) => response.data) 
      );
  }

  fetchUserSuperadmin(userId: string): Observable<any> {
    return this.#http
      .get(`${this.#apiUrl}/api/superadmin/${userId}`, {
        headers: this.#authHeaders,
      })
      .pipe(
        map((response: any) => response.data )
     
      );
  }
  getApiUrl(): string {
    return this.#apiUrl;
  }
}
